"use client";;
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export const Suggestions = ({
    className,
    children,
    ...props
}) => (
    <div className={cn("flex flex-wrap items-center justify-center gap-2 w-full", className)} {...props}>
        {children}
    </div>
);

export const Suggestion = ({
    suggestion,
    onClick,
    className,
    variant = "outline",
    size = "sm",
    children,
    ...props
}) => {
    const handleClick = () => {
        onClick?.(suggestion);
    };

    return (
        <Button
            className={cn(
                "cursor-pointer rounded-full px-4 hover:border-primary/40 hover:bg-primary/5 transition-all",
                className
            )}
            onClick={handleClick}
            size={size}
            type="button"
            variant={variant}
            {...props}>
            {children || suggestion}
        </Button>
    );
};
